import React from 'react';
import { UploaderImage } from '../_atoms';
import '../styles/books_in_exemplar_cover.scss';

export const BooksInExemlarCover = ({ images, addPhoto, deletePhoto, saveCurrentPictOrder, changePictOrder }) => {
  // nameMass - name in state (App.js) and in input
  const nameMass = 'coverImages';
  const pictMass = [];
  for (let i = 0; i < 4; i += 1) {
    pictMass.push(
      <UploaderImage
        key={i}
        i={i}
        nameMass={nameMass}
        addPhoto={addPhoto}
        deletePhoto={deletePhoto}
        item={images[i]}
        saveCurrentPictOrder={saveCurrentPictOrder}
        changePictOrder={changePictOrder}
      />
    );
  }
  return <div className="books-in-exemplar cover">{pictMass}</div>;
};
